import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";

import { ListAlertsPage } from "./pages/list/ListAlertsPage";
import { SettingsAlertsPage } from "./pages/settings/SettingsAlertsPage";
import { alertsRoutes } from "./routes";

export const alertsRoute = [
  {
    path: alertsRoutes.list,
    element: <ListAlertsPage />,
  },
  {
    path: alertsRoutes.settings,
    element: <SettingsAlertsPage />,
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
